// extracted by mini-css-extract-plugin
module.exports = {"root":"GlobalContainer_root__1jDyR","header--dashboard":"GlobalContainer_header--dashboard__1yyT_","header":"GlobalContainer_header__2eJB5"};